const alertIconMap = {
  success: 'check-circle',
  danger: 'exclamation-circle',
  warning: 'exclamation-triangle',
  info: 'info-circle',
  primary: '',
  secondary: '',
  dark: '',
  light: '',
}

export { alertIconMap }
